export enum VendorId {
    MERCADO_PAGO = 'MERCADO_PAGO',
    EMPTY = 'EMPTY'
}
